export const demoUserData = {
  userType: "demo",
  companyName: "demo.demo",
  email: "demo@mail.com",
  firstName: "Demo",
  lastName: "Demo",
  phoneNumber: "+00 000 000",
  jobFunction: "demo"
};
